export const AUTH_ROUTES = {
  LOGIN: 'login',
  REGISTRATION: 'registration',
  REGISTRATION_TYPE: 'registration-type',
} as const;

export const ROUTES = {
  CMS_EVENT_MANAGEMENT: 'cms/event-management',
  CMS_ORGANIZATION_MANAGEMENT: 'cms/organization-management',
  CMS_CATEGORY_MANAGEMENT: 'cms/category-management',
  CMS_DISTANCE_MANAGEMENT: 'cms/distance-management',
  CMS_GROUP_MANAGEMENT: 'cms/group-management',
  MY_CALENDAR: 'my-calendar',
  MY_ACCOUNT: 'my-account',
  RESULTS: 'results',
  CONTACT_US: 'contact-us',
} as const;
